/**
 * 角色用户模块接口
 * name：接口名称
 * url：接口api
 * method：接口请求方法，默认GET
 * defaultParams：默认参数
 */

export default [
  //  查询用户信息
  {
    name: 'getUserInfo',
    url: '/api/aam/v1/portal/user/info'
  },

  //  获取组织树数组类型,grounpId
  {
    name: 'getOrganTree2',
    url: '/api/aam/v1/portal/orgs/government/{@}/trees'
  },
  //  获取组织树
  {
    name: 'getOrganTree',
    url: '/api/aam/v1/mgmt/groups/government/{@}'
  },
  //  获取组织成员
  {
    name: 'getOrganMember',
    url: '/api/aam/v1/mgmt/groups/government/{@}/members'
  },
  //  新增部门或组织
  {
    name: 'addDep',
    url: '/api/aam/v1/mgmt/groups/government',
    method: 'POST'
  },
  //  更新部门
  {
    name: 'putDep',
    url: '/api/aam/v1/mgmt/groups/government/{@}',
    method: 'PUT'
  },
  // 删除部门
  {
    name: 'delDep',
    url: '/api/aam/v1/mgmt/groups/government/{@}',
    method: 'DELETE'
  },
  // 新增用户
  {
    name: 'addUser',
    url: '/api/aam/v1/mgmt/users/random-password',
    method: 'POST'
  },
  // 给用户绑定组织 userId
  {
    name: 'setUserOrgan',
    url: '/api/aam/v1/mgmt/users/{@}/groups/government',
    method: 'PUT'
  },
  // 修改用户信息
  {
    name: 'putUser',
    url: '/api/aam/v1/mgmt/users/{@}',
    method: 'PUT'
  },
  // 给用户绑定角色 userId
  // {
  //   name: "putUser",
  //   url: "/api/aam/v1/mgmt/users/{@}/groups/government",
  //   method: "POST"
  // },
  // 获取用户所属角色 userId
  {
    name: 'getUserRoles',
    url: '/api/aam/v1/mgmt/users/{@}/roles',
    method: 'GET'
  },
  // 重置密码
  {
    name: 'resetPass',
    url: '/api/aam/v1/mgmt/users/{@}/random-password',
    method: 'PUT'
  },
  // 获取密码 userId
  {
    name: 'getPass',
    url: '/api/aam/v1/mgmt/users/{@}/random-password'
  },
  // 获取添加用户,部门级联 orgLevel
  {
    name: 'getDepCascade',
    url: '/api/aam/v1/mgmt/groups/government/{@}/groups'
  }
]
